<template>
  <div class="col-sm-6 col-md-4">
    <div class="card">
      <h5 class="card-header" :class="{ sodanger: insufficientFunds }">{{ stock.name }}</h5>
      <div class="card-body">
        <p>Price: ${{ stock.price }}</p>
        <input
          type="number"
          class="form-control"
          placeholder="Quantity"
          v-model="quantity"
          :class="{dangerous: insufficientFunds}"
        >
        <button
          class="btn btn-success mt-2"
          @click="buyStock"
          :disabled="quantity <= 0 || insufficientFunds"
        >{{ insufficientFunds ? 'Insufficient Funds' : 'Buy' }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .dangerous {
    border: 1px solid red;
  }
  .sodanger {
    color: red;
  }
</style>

<script>
export default {
  props: ['stock'],
  data () {
    return {
      quantity: 0,
    }
  },
  computed: {
    funds() {
      return this.$store.getters.funds;
    },
    insufficientFunds () { // Lecture 296
      return this.quantity * this.stock.price > this.funds;
    }
  },
  methods: {
    buyStock() { // Lecture 289
      const order = {
        stockId: this.stock.id,
        stockPrice: this.stock.price,
        quantity: this.quantity,
      };
      console.log(order);
      console.log(this.funds)
      if (this.stock.price * this.quantity < this.funds) {
        this.$store.dispatch('buyStock', order);
        this.quantity = 0;
      } else {
        return alert('You dont have enough money!')
      }

    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/stocks/Stock.vue